

const BlockLit = () => {
    return (
        <section id="portfolio-details" className="portfolio-details" style={{ marginTop: '5rem' }}>
            <div className="container">
                <div className="row gy-4">
                    <div className="col-lg-8">
                        <div className="portfolio-description">
                            <h2>Blocklit</h2>
                            <p>
                                El Proyecto Blocklit tiene un objetivo claro: empoderar a los escritores mediante la tecnología blockchain, brindándoles un nivel de control sobre sus obras nunca antes visto. Además, busca llevar la relación entre lectores y escritores un paso más allá, fomentando una colaboración activa a través de un sistema de recompensas basado en blockchain.</p>
                            <p>
                                Blocklit aspira a convertirse en un universo descentralizado y completamente transparente, donde los autores tengan un control absoluto sobre sus obras, sin depender de terceros para publicarlas. Creemos firmemente que los autores merecen tener el control total sobre los beneficios generados por sus obras y la libertad de expresar plenamente su creatividad.</p>
                            <p>
                                El Proyecto Blocklit va mucho más allá de ser una plataforma descentralizada para que los autores vendan sus obras. Nuestra visión es transformar por completo la experiencia de lectura y escritura, permitiendo que los lectores también participen activamente en todo el proceso.
                            </p>
                            <p>
                                Además de brindar a los autores un control sin precedentes sobre sus obras, Blocklit ofrece a los lectores la oportunidad única de vender las obras una vez que las han disfrutado por completo, compartiendo los beneficios de la venta de manera justa y directa con el autor original. De esta forma, garantizamos que el autor siempre obtenga un beneficio económico por cada obra que se venda, reconociendo su talento y esfuerzo.
                            </p>
                            <p>
                                Creemos firmemente en la relación simbiótica entre el autor y el lector, ya que ambos desempeñan un papel crucial en el éxito de una obra. Es por eso que hemos implementado un sistema de recompensas basado en tokens ERC20, con el objetivo de fomentar la colaboración activa entre lectores y escritores. Al incentivar esta colaboración, fortalecemos aún más la conexión entre ambas partes y enriquecemos la experiencia literaria para todos.
                            </p>
                            <p>
                                En Blocklit, nuestro objetivo es construir una comunidad comprometida con el arte y la literatura y la defensa de la libertad de expresión, donde el talento de los autores sea recompensado justamente y los lectores se sientan motivados a involucrarse activamente en el apoyo a sus escritores favoritos.
                            </p>

                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="portfolio-info">
                            <h3>Información del Proyecto</h3>
                            <ul>
                                <li><strong>Categoria</strong>: Web3, Blockchain</li>
                                <li><strong>Fecha de inicio</strong>: 25 de Junio, 2023</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default BlockLit;
